import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useAutoId } from './helpers';

Check.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  labelHidden: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
export default function Check({
  name,
  value,
  onChange,
  checked = false,
  disabled = false,
  labelHidden = false,
  children,
}) {
  const autoId = useAutoId('check');

  return (
    <div className="check_cover">
      <input
        type="checkbox"
        id={autoId}
        className="lw_checkbox"
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
      />
      <label htmlFor={autoId} className={classNames({ blind: labelHidden })}>
        {children}
      </label>
    </div>
  );
}
